import {useEffect, useState} from "react";
import {ArrowLeftIcon} from "../components/kits/Icons/Icons";
import {Helmet} from "react-helmet";
import {addCommas} from "@persian-tools/persian-tools";
import Drawer from "../components/drawer/Drawer.jsx";
import CustomButton from "../components/kits/custom-button/CustomButton";
import {CustomInput} from "../components/kits/inputs/Input.tsx";
import colorSchema from "../assets/kits/colors";
import useWindowSize from "../hooks/useWindowSize.jsx";
import DeleteCartItemDrawer from "../components/common/shoppingBaskets/DeleteCartItemDrawer.jsx";
import DiscountCodeDrawer from "../components/check-out/DiscountCodeDrawer.jsx";
import ProductDetailDrawer from "../components/check-out/ProductDetailDrawer.jsx";
import OrderDrawer from "../components/orders/OrderDrawer.jsx";
import ProductCard from "../components/common/ProductCard/ProductCard";
import FailPaymentDrawer from "../components/check-out/FailPaymentDrawer.jsx";
import DrawerTxtBtn from "../components/common/DrawerTxtBtn";
// import ColorSchema from "../assets/kits/colors";

// import Loader from "../components/kits/Loader";

import image from "../assets/images/img1.jpg";
import BoxSlider from "../components/common/slider/BoxSlider";
import {getBoxByPosition} from "../utilities/apiTools";
import SearchProductDrawer from "../components/product-search/SearchProductDrawer";
import {Button} from "react-bootstrap";
// import SnackBar from "../components/kits/SnackBar";
// import useSnackBar from "../components/kits/SnackBar/useSnackBar";

export default function UIKits() {
    const [counter, setCounter] = useState(0);
    const [loading, setLoading] = useState(false);
    const [offCode, setOffCode] = useState("");

    const [items, setItems] = useState([
        {
            title: "نام کالا",
            current_count: "1",
            price: "84000",
        },
        {
            title: "نام کالا",
            current_count: "2",
            price: "84000",
        },
        {
            title: "نام کالا",
            current_count: "3",
            price: "84000",
        },
        {
            title: "نام کالا",
            number: "10",
            price: "84000",
        },
        {
            title: "نام کالا",
            current_count: "1",
            price: "84000",
        },
        {
            title: "نام کالا",
            current_count: "2",
            price: "84000",
        },
        {
            title: "نام کالا",
            current_count: "3",
            price: "84000",
        },
        {
            title: "نام کالا",
            number: "10",
            price: "84000",
        },
        {
            title: "نام کالا",
            current_count: "1",
            price: "84000",
        },
    ]);
    const [isOpen, setIsOpen] = useState(true);
    // const winSize = useWindowSize();



    return (
        <>
            <Button onClick={() => setIsOpen(true)}>
                نمایش
            </Button>

            <SearchProductDrawer open={isOpen} setIsOpen={setIsOpen}/>
        </>
    )


    // return (
    //   <div>
    //     <div className="d-flex flex-wrap ">
    //       <Helmet>
    //         <title>UI Kits</title>
    //       </Helmet>
    //     </div>
    //     <div className="mt-4">
    //       <ProductCard
    //         imagePath={image}
    //         width={161}
    //         title="عنوان محصول"
    //         price={1200000}
    //         cartItemCount={counter}
    //         link="product/6/93"
    //         loading={loading}
    //         plusOnClick={() => {
    //           setLoading(true);
    //           setCounter((prev) => prev + 1);
    //           setTimeout(() => setLoading(false), 2000);
    //         }}
    //         minusOnClick={() => {
    //           setLoading(true);
    //           setCounter((prev) => prev - 1);
    //           setTimeout(() => setLoading(false), 2000);
    //         }}
    //       />
    //       <ProductCard
    //         imagePath={image}
    //         width={161}
    //         title="عنوان محصول"
    //         price={1200000}
    //         discount={15}
    //         cartItemCount={counter}
    //         link="product/6/93"
    //         loading={loading}
    //         plusOnClick={() => {
    //           setLoading(true);
    //           setCounter((prev) => prev + 1);
    //           setTimeout(() => setLoading(false), 2000);
    //         }}
    //         minusOnClick={() => {
    //           setLoading(true);
    //           setCounter((prev) => prev - 1);
    //           setTimeout(() => setLoading(false), 2000);
    //         }}
    //       />
    //     </div>
    //     <button onClick={() => setDrawerTxtBtnIsOpen(true)}>ddd</button>
    //     <DrawerTxtBtn
    //       isOpen={drawerTxtBtnIsOpen}
    //       setIsOpen={setDrawerTxtBtnIsOpen}
    //       height={135}
    //       mainText="متن دلخواه"
    //       btnText="متن دلخواه"
    //       to="shop/2"
    //     />
    //
    //     {/* <DeleteCartItemDrawer
    //       isOpen={isOpen}
    //       setIsOpen={setIsOpen}
    //       // supplierId={supplierId}
    //     ></DeleteCartItemDrawer> */}
    //
    //     {/* <ProductDetailDrawer
    //       isOpen={isOpen}
    //       setIsOpen={setIsOpen}
    //       items={items}
    //     ></ProductDetailDrawer> */}
    //
    //     {/* <DiscountCodeDrawer
    //       isOpen={isOpen}
    //       setIsOpen={setIsOpen}
    //     ></DiscountCodeDrawer> */}
    //
    //     {/* <OrderDrawer
    //       isOpen={isOpen}
    //       setIsOpen={setIsOpen}
    //       items={items}
    //       delivery="9000"
    //     ></OrderDrawer> */}
    //
    //     <FailPaymentDrawer
    //       isOpen={isOpen}
    //       setIsOpen={setIsOpen}
    //     ></FailPaymentDrawer>
    //
    //     <div className="w-100 d-flex justify-content-center align-items-center flex-column">
    //       <CustomButton
    //         buttonStyle="primary"
    //         size="large"
    //         // state="disable"
    //         icon={<ArrowLeftIcon />}
    //         iconPosition="right"
    //         onClick={() => {
    //           setIsOpen(true);
    //         }}
    //       >
    //         متن دکمه
    //       </CustomButton>
    //       <br />
    //     </div>
    //     {/* <CustomButton
    //         buttonStyle="secondary"
    //         size="large"
    //         state="disable"
    //         icon={<ArrowLeftIcon />}
    //         iconPosition="right"
    //       >
    //         متن دکمه
    //       </CustomButton>
    //       <br />
    //       <CustomButton
    //         buttonStyle="text"
    //         size="large"
    //         // state="disable"
    //         icon={<ArrowLeftIcon />}
    //         iconPosition="right"
    //       >
    //         متن دکمه
    //       </CustomButton>
    //     </div> */}
    //   </div>
    // );
}
